import { UseDoLoginMutationContext } from '../../bo-kit/components/SignInPage/components/Form/hooks/useLogin';
import { FC, PropsWithChildren } from 'react';
import { useLoginMutation } from '../gatewayApi';

export const UseDoLoginMutationContextProvider: FC<PropsWithChildren> = ({ children }) => {
    const [doLogin, loginState] = useLoginMutation();
    return (
        <UseDoLoginMutationContext.Provider value={[doLogin, loginState]}>
            {children}
        </UseDoLoginMutationContext.Provider>
    );
};
